import Splide from '@splidejs/splide';
import { SlideNumber } from './components/SlideNumber/SlideNumber';

const testimonials = [...document.getElementsByClassName("splide--testimonials")];
const articleteasers = [...document.getElementsByClassName("splide--article-teaser")];
const sliders = [...document.querySelectorAll('[data-slider]')]

if(testimonials.length > 0) {
    testimonials.forEach(testimonialTeaser => {
        new Splide(testimonialTeaser, {
            classes: {
                page: 'splide__pagination-page'
            }
        }).mount();
    });
}

if(articleteasers.length > 0) {
    articleteasers.forEach( articleTeaser => {
        new Splide(articleTeaser, {
            perPage: 2,
            perMove: 1,
            gap: '7.5rem',
            classes: {
                page: 'splide__pagination-page'
            },
            breakpoints: {

                767: {
                    perPage: 1,
                    gap: '2.5rem',
                    padding: {
                        right: '5.6rem'
                    },

                }
            },
        }).mount();
    });
}


sliders.forEach( slider => {
    new Splide(slider, {
        classes: {
            page: 'splide__pagination-page'
        }
    }).mount( {
        SlideNumber
    } );
} )